// References:
// https://github.com/wix-private/scheduler/blob/master/statics/owner/bookings-calendar-statics/src/query-builder.ts
// https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_the-filter-section
var hasSome = function (values) {
    if (values === void 0) { values = []; }
    return ({
        build: function () {
            return { $hasSome: values };
        },
    });
};
var hasAll = function (values) {
    if (values === void 0) { values = []; }
    return ({
        build: function () {
            return { $hasAll: values };
        },
    });
};
var gte = function (values) {
    if (values === void 0) { values = []; }
    return ({
        build: function () {
            return { $gte: values };
        },
    });
};
var equal = function (value) { return ({
    build: function () {
        return { $eq: value };
    },
}); };
var exists = function (value) { return ({
    build: function () {
        return { $exists: value };
    },
}); };
function buildCondition(cond) {
    var _a;
    if (typeof cond.build === 'function') {
        return cond.build();
    }
    var _b = Object.entries(cond)[0], key = _b[0], value = _b[1];
    var condValue = typeof value.build === 'function';
    return _a = {}, _a[key] = condValue ? value.build() : value, _a;
}
function or(firstCond) {
    var conditions = [buildCondition(firstCond)];
    return {
        or: function (cond) {
            conditions.push(buildCondition(cond));
            return this;
        },
        build: function () {
            return {
                $or: conditions,
            };
        },
    };
}
function and(firstCond) {
    var conditions = [buildCondition(firstCond)];
    return {
        and: function (cond) {
            conditions.push(buildCondition(cond));
            return this;
        },
        build: function () {
            return {
                $and: conditions,
            };
        },
    };
}
export { or, hasSome, and, gte, equal, exists, hasAll, buildCondition };
//# sourceMappingURL=query-builder.js.map